export default __webpack_public_path__ + "static/media/Committees_Icon.b73c7df3.svg";